import { pageSchemaScript } from "@/seo/schema";
import { createFileRoute } from "@tanstack/react-router";
import { SECTION_OG, sectionImageMeta } from "@/lib/ogSections";
import { PageShell, PageHero } from "@/components/PageShell";
import { Reveal } from "@/components/Reveal";
import { Mic, Video, Newspaper, Linkedin } from "lucide-react";

const SECTIONS = [
  { Icon: Video, title: "Videos & Talks", items: ["Seminar clips on intelligent buildings", "Owner & architect briefings", "On-site walkthroughs and explainers"] },
  { Icon: Mic, title: "Podcast & Interviews", items: ["The Future of Perimeter Defence — Industry Podcast 2024", "Luxury Living Technology — Owner Briefings"] },
  { Icon: Linkedin, title: "LinkedIn Features", items: ["Thought-leadership series on building technology", "Project debriefs and lessons learned"] },
  { Icon: Newspaper, title: "Media Updates", items: ["Industry coverage across security and AV publications", "Educational insights on automation and AV"] },
];

const MEDIA_TITLE = "Media — Videos, Talks & Educational Insights | Arif Khan";
const MEDIA_DESC =
  "Videos, talks, media updates, seminar clips, and educational insights from Arif Khan on security, automation, AV, and intelligent building technology.";

export const Route = createFileRoute("/insights/media")({
  component: MediaPage,
  head: () => ({
    meta: [
      { title: MEDIA_TITLE },
      { name: "description", content: MEDIA_DESC },
      { property: "og:title", content: "Media — Videos, Talks & Insights | Arif Khan" },
      { property: "og:description", content: "Videos, talks, seminar clips and educational insights on security, automation and AV." },
      { property: "og:url", content: "https://arifkhanglobal.com/insights/media" },
      ...sectionImageMeta(SECTION_OG.askArif, "Media & press — Arif Khan"),
    ],
    links: [
      { rel: "canonical", href: "https://arifkhanglobal.com/insights/media" },
    ],
    scripts: [
      pageSchemaScript({
        path: "/insights/media",
        type: "CollectionPage",
        name: MEDIA_TITLE,
        description: MEDIA_DESC,
        breadcrumb: [
          { name: "Insights", url: "/insights" },
          { name: "Media", url: "/insights/media" },
        ],
      }),
    ],

  }),
});

function MediaPage() {
  return (
    <PageShell>
      <PageHero
        eyebrow="Media"
        title="Videos, talks and educational insights from the field."
        description="Media updates, seminar clips, podcast appearances and educational content on security, automation, AV and intelligent building technology."
      />
      <section className="py-24">
        <div className="container-page grid md:grid-cols-2 gap-px bg-border border border-border rounded-2xl overflow-hidden">
          {SECTIONS.map((s, i) => (
            <Reveal key={s.title} delay={i * 0.05}>
              <div className="bg-background p-10 h-full">
                <div className="inline-flex h-11 w-11 items-center justify-center rounded-xl bg-primary-soft text-primary mb-6">
                  <s.Icon className="h-5 w-5" strokeWidth={1.6} />
                </div>
                <h3 className="text-xl font-semibold">{s.title}</h3>
                <ul className="mt-5 space-y-3 text-ink-soft">
                  {s.items.map((it) => <li key={it} className="text-sm leading-relaxed">— {it}</li>)}
                </ul>
              </div>
            </Reveal>
          ))}
        </div>
      </section>
    </PageShell>
  );
}
